export default __webpack_public_path__ + "static/media/error500.b02c9cfe.png";